import { render } from "./ProjectForm.vue?vue&type=template&id=694f1734&scoped=true&ts=true"
import script from "./ProjectForm.vue?vue&type=script&lang=ts"
export * from "./ProjectForm.vue?vue&type=script&lang=ts"

import "./ProjectForm.vue?vue&type=style&index=0&id=694f1734&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694f1734"]])

export default __exports__